<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'sm'"
    :modal-id="'reorder-section'"
    @hidden="$emit('onCloseModal')"
  >
    <template #modal-header>
      <div class="font-medium-5 text-black font-weight-bolder">
        Move sections
      </div>
    </template>
    <div>
      <draggable
        :componentData="componentData"
        :list="sectionMove"
        :animation="100"
        @start="dragging = true"
        @end="dragging = false"
        item-key="name"
        handle=".handle"
        class="section-container"
        ghost-class="bg-darging"
        :scroll-sensitivity="300"
      >
        <div
          v-for="(section, index) in sectionMove"
          :key="section.sectionid"
          class="section-move-wrp"
          @click="toggleActive(section.sectionid)"
        >
          <div class="d-flex d-flex align-item-center">
            <div class="mr-2 section-move handle">
              <icon-drag-drop class="icon-reorder cursor-pointer" />
            </div>
            <div class="d-flex flex-column">
              <div class="section-name">
                {{ section.sec_name_htmleditor.replace(/<[^>]*>/g, "") }}
              </div>
              <div class="font-small-5 section-count">
                Section {{ index + 1 }} of
                {{ formQuestion.length }}
              </div>
            </div>
          </div>
        </div>
      </draggable>

      <b-row>
        <b-col>
          <div class="modal-btn-wrp btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center mt-2">
              <cancel-button
                class="mr-1 cencel-button"
                :btn-label="'Back'"
                @click.native="$emit('onCloseModal')"
              />
              <save-button
                :btnLabel="'Save'"
                type="submit"
                class="ml-1 btn-save"
                @click.native="onSaveReoder"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </base-modal>
</template>

<script>
import draggable from "vuedraggable";
import IconDragDrop from "@/@core/components/svg/common/IconDragDrop.vue";
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  getCurrentInstance,
  computed,
} from "@vue/composition-api";

export default {
  components: {
    draggable,
    IconDragDrop,
  },
  props: {
    formQuestion: { type: Array },
    sectionMove: { type: Array },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const formData = reactive({
      sectionActive: 0,
      sectionData: [],
      questionList: [],
      questionName: {},
    });

    const questionName = computed(() => {});

    const componentData = reactive({
      type: "transition",
      name: "flip-list",
    });

    const toggleActive = (sectionId) => {
      formData.sectionActive = sectionId;
    };

    const onSaveReoder = () => {
      vm.$emit("onSaveReoder", props.sectionMove);
    };

    return {
      componentData,
      toggleActive,
      formData,
      onSaveReoder,
      questionName,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/survey/question.css";

#reorder-section .bg-darging {
  background-color: #e8ebf1;
  border-top: 1px solid #007fff;
  border-bottom: 1px solid #007fff;
}
</style>